export function distinctById(array) {
    return array.filter((obj, index) => {
        const findIndex = array.findIndex(obj1 => obj1.id === obj.id)
        return findIndex === index;
    })
}

export function decodePositionId(encoded) {
  let result = '';
  let i = 0;

  while (i < encoded.length) {
    // Смотрим префикс
    const prefix = encoded[i];

    if (prefix === '0') {
      // Следующий символ – просто цифра
      result += encoded[i + 1];
      i += 2;
    } else {
      // prefix === '1', значит за ним 3 цифры – это ASCII-код
      const codeStr = encoded.substr(i + 1, 3);
      const code = parseInt(codeStr, 10);
      result += String.fromCharCode(code);
      i += 4;
    }
  }
  return result;
}

export function encodePositionId(str) {
  let result = '';
  for (let i = 0; i < str.length; i++) {
    const ch = str[i];
    // Если это цифра:
    if (/[0-9]/.test(ch)) {
      // Пишем '0' + сама цифра
      result += '0' + ch;
    } else {
      // Иначе (буква)
      const code = ch.charCodeAt(0);             // ASCII-код символа
      const codeStr = String(code).padStart(3, '0');
      // Пишем '1' + 3-значный код
      result += '1' + codeStr;
    }
  }
  return result;
}